import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { TARA_CHAT_API } from '../../constants/central-api';

export default async function tara_chat_history_api_call(
  page = 1,
  per_page = 5
) {
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  const shop_slug = store.getState().user.company.shop_slug;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  if (!shop_slug || shop_slug === '') return false;

  const requestInfo: RequestInfo = {
    url: `${TARA_CHAT_API(shop_slug)}?per_page=${per_page}&page=${page}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_TARA_CHAT_HISTORY_API';
  const customMsg = 'Tara Chat History API Successful.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;
  if (!response.success) {
    return false;
  }
  if (res.actionType === actionType && response.success === true) {
    if (response?.data === null) {
      return null;
    } else {
      // Return the whole object with data, links, and meta.
      return response?.data;
    }
  }
}
